import { useContextStore } from "@/store/context";

export default defineNuxtPlugin(({ $pinia }) => {
  const contextStore = useContextStore($pinia);
  contextStore.setBrowser();
  if (!contextStore.isSupportedBrowser) {
    contextStore.setPopinBrowserDeprecatedVisible(true);
  }
});
